import request from '@/request/request.js'
import baseUrl from "@/request/config";

// ==================== AI 生成相关接口 ====================

/**
 * 获取关键词列表
 * @param {Object} params - 请求参数
 * @returns {Promise}
 */
export function getKeywords(params) {
    return request({
        url: baseUrl +'/article/ai/keywords',
        method: 'get',
        params: params
    })
}

/**
 * 获取文献列表（支持关键词、分类、类型筛选）
 * @param {Object} params - 请求参数
 * @param {string} params.liteName - 文献名称（搜索关键词）
 * @param {number} params.departmentId - 分类ID（可选）
 * @param {string} params.type - 类型（literature/case）
 * @param {number} params.pageNum - 页码（默认1）
 * @param {number} params.pageSize - 每页大小（默认10）
 * @returns {Promise}
 */
export function getLiterature(params) {
    return request({
        url: baseUrl +'/article/ai/literature',
        method: 'get',
        params: params
    })
}

/**
 * 获取分类列表（用户端）
 * @param {string} type - 类型（literature/case）
 * @returns {Promise}
 */
export function getDepartmentList(type) {
    return request({
        url: baseUrl +'/article/ai/department/list',
        method: 'get',
        params: { type: type }
    })
}

/**
 * 提交AI生成任务
 * @param {Object} params - 请求参数
 * @param {string} params.filePath - 文件路径（文献解读时使用）
 * @param {string} params.keywords - 关键词
 * @param {string} params.documentType - 文档类型（01-科普征文，02-文献解读）
 * @param {string} params.inputType - 输入类型（01-选择方向，02-手动输入）
 * @param {string} params.aiWords - 期望字数
 * @returns {Promise}
 */
export function generateAI(params) {
    return request({
        url: baseUrl +'/article/ai/generate',
        method: 'post',
        data: params
    })
}

/**
 * 查询AI生成结果
 * @param {Object} params - 请求参数
 * @param {string} params.flagId - 任务ID
 * @returns {Promise}
 */
export function getGenerateAI(params) {
    return request({
        url: baseUrl +'/article/ai/generate/result',
        method: 'get',
        params: params
    })
}

/**
 * 获取AI生成记录列表
 * @param {Object} params - 请求参数
 * @param {string} params.orgId - 机构ID
 * @returns {Promise}
 */
export function generateList() {
    return request({
        url: baseUrl +'/article/ai/generate/list',
        method: 'get'
    })
}

/**
 * 更新AI生成的文章内容
 * @param {Object} params - 请求参数
 * @param {string} params.genId - 生成记录ID
 * @param {string} params.content - 更新后的内容
 * @returns {Promise}
 */
export function updateGenerateArticle(params) {
    return request({
        url: baseUrl +'/article/ai/generate/update',
        method: 'post',
        data: params
    })
}



// ==================== 文档相关接口 ====================

/**
 * 获取文档列表
 * @param {Object} params - 请求参数
 * @returns {Promise}
 */
export function listDocument(params) {
    return request({
        url: baseUrl +'/article/document/list',
        method: 'get',
        params: params
    })
}

/**
 * 添加文档
 * @param {Object} params - 请求参数
 * @returns {Promise}
 */
export function addDocument(params) {
    return request({
        url: baseUrl +'/article/document/add',
        method: 'post',
        data: params
    })
}

/**
 * 从AI任务投稿
 * @param {string} genId - AI生成任务ID
 * @returns {Promise}
 */
export function saveFromAI(genId) {
    return request({
        url: baseUrl +'/article/document/saveFromAI',
        method: 'post',
        data: { genId }
    })
}

/**
 * 获取项目AI功能配置
 * @param {string} projectId - 项目ID
 * @returns {Promise}
 */
export function getAIConfig(projectId) {
    return request({
        url: baseUrl + '/article/project/ai/config/' + projectId,
        method: 'get'
    })
}
